import { FilterRuleItem } from './FilterRuleItem';

export const FilterRulesList = ({ filterRows, getLogicalOperatorText, getActiveFiltersCount }) => {
    return (
        <div style={{
            flex: 1,
            maxHeight: "30vh",
            overflowY: "auto",
            padding: "0 0.5rem 1rem 0.5rem",
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            marginRight: "0.25rem",
        }}>
            <div style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "1.5rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                border: "1px solid #dee2e6",
                margin: "0 0.25rem"
            }}>
                <h3 style={{
                    margin: "0 0 1rem 0",
                    color: "#495057",
                    fontSize: "16px",
                    fontWeight: "600"
                }}>Filter Configuration</h3>
                
                {getActiveFiltersCount() === 0 ? (
                    <div style={{
                        textAlign: "center",
                        padding: "2rem",
                        color: "#6c757d",
                        fontStyle: "italic"
                    }}>
                        No active filters configured
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                        {filterRows?.filter(row => row.column && row.operator).map((filterRow, index) => (
                            <FilterRuleItem 
                                key={filterRow.id || index}
                                filterRow={filterRow}
                                getLogicalOperatorText={getLogicalOperatorText}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
